.container {
  width: 8px;
  height: 100%;
  cursor: ew-resize;
}
